import { CelumPropertiesProvider } from '@celum/core';
import { SpecificationTypeFilter } from '@celum/formats/domain';

export function getSpecificationTypeFilters(): {
  key: SpecificationTypeFilter;
  label: string;
  value: string[];
}[] {
  const formats = CelumPropertiesProvider.properties?.appProperties?.formats;

  return [
    {
      key: SpecificationTypeFilter.DOWNLOAD,
      label: 'FORMAT_LIST.FILTERS.DOWNLOAD',
      value: formats?.downloadSpecificationTypes?.split(',') ?? []
    },
    {
      key: SpecificationTypeFilter.OTHERS,
      label: 'FORMAT_LIST.FILTERS.OTHERS',
      value: formats?.otherSpecificationTypes?.split(',') ?? []
    }
  ];
}

export const specificationNoneFilter = {
  key: 'none',
  label: 'FORMAT_LIST.FILTERS.NONE_SPEC'
};
